import { Controller } from "@hotwired/stimulus"

// Auto-fills the slug input from the name input until the user manually
// edits the slug. After a manual edit, name changes no longer overwrite slug.
export default class extends Controller {
  static targets = ["name", "slug"]

  declare readonly nameTarget: HTMLInputElement
  declare readonly slugTarget: HTMLInputElement

  private touched = false

  connect(): void {
    // If the slug is already non-empty on page load (edit view), treat as touched.
    this.touched = this.slugTarget.value.trim().length > 0
  }

  markTouched(): void {
    this.touched = true
  }

  updateSlug(): void {
    if (this.touched) return
    this.slugTarget.value = this.slugify(this.nameTarget.value)
  }

  private slugify(value: string): string {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }
}
